import React from 'react';
import { Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

export default function EmailComponent({ control, name, disabled }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: 'Invalid email format',
        },
      }}
      render={({ field, fieldState }) => (
        <>
          <InputText
            placeholder="Enter email"
            id={field.name}
            value={field.value || ''}
            onChange={(e) => field.onChange(e.target.value)}
            className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
            disabled={disabled}
          />
          {fieldState.error?.message && <InputErrorMessage>{fieldState.error?.message}</InputErrorMessage>}
        </>
      )}
    />
  );
}
